import * as React from "react"
import { connect } from "react-redux"
import { toast } from "react-toastify"
import { RouteComponentProps } from "react-router"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import { Button, Col, Form, InputGroup, Modal, ModalBody, Spinner } from "react-bootstrap"
import { Subscription } from "rxjs"
import ActionButton from "../ActionButton"
import AccountInput from "../FormattedInputs/AccountInput"
import AutoFilterCompany from "../../api/Companies/CompanyModel/AutoFilterCompany"
import { AppState } from "../../AppState"
import FormatError from "../../formatters/FormatError"
import { Home } from "../../config/Routes"
import { isCompanyAdmin, isLocationAdmin, isPortalAdmin, isSiteAdmin } from "../../authentication/isAdminRole"
import getWorkforceReport, { WorkforceReportRecord, Report, WorkforceReportType, RegulatoryModesGet, YearListGet, ManagementSummaryReport, MISReport, ManagementSummaryReportGenerate, MISReportGenerate, SelectedNotTestedReportGenerate } from "../../api/Reports/WorkforceReport"
import { GetSelectedAssignedClinic } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import ToggleSwitch from "../FormattedInputs/ToggleSwitch"
import FromToDates from "./FromToDates"
import FormatDate from "../../formatters/FormatDate"
import { AccountTypeID, DonorIdRegexp, InvalidDonorId, MaxDonorIdLength } from "../../config/Constants"
import DriverCertificationReportGet from "../../api/Reports/DriverCertificationReportGet"
import printPdf from "../../utils/printPdf"
import { AccountType } from "../../config/Constants"
import DualListBox from "../../components/Administration/DualListBox"
import { GetAllAccountsByNameObservable } from "../../api/Companies/GetAccountsByName"
import LocationInput from "../FormattedInputs/LocationInput"
import { Pool } from "../../api/Randoms/RandomsModel/PoolData"
import TextFormControl from "../OrderRequests/TextFormControl"
import { FaAngleDown, FaSearch } from "react-icons/fa"
import { SearchDonorGetObservable } from "../../api/OrderRequests/SearchDonorGet"
import { Donor } from "../../api/OrderRequests/OrderRequestsModel/Donor"
import { GetRegulatoryModeDonor } from "../OrderRequests/OrderModels"
import { RegulatoryModeObservable } from "../../api/OrderRequests/OrderRequestsConstraintGet"
import CompanyInput from "../FormattedInputs/CompanyInput"
import { AsyncTypeahead } from "react-bootstrap-typeahead"
import { PoolsGetObservable } from "../../api/Randoms/PoolGeneralInfoGet"
import { FaFileCsv, FaFilePdf} from "react-icons/fa"
import exportCsv from "../../utils/exportCsv"
import FormatTimestampFileName from "../../formatters/FormatTimestampFileName"

interface WorkforceReportParametersProps {
  isLocationAdmin?: boolean
  isCompanyAdmin?: boolean
  isPortalAdmin?: boolean
  isSiteAdmin?: boolean
  company?: number
}

interface WorkforceReportParametersState {
  report: WorkforceReportRecord
  from?: Date
  to?: Date
  regulatoryModes: string[]
  statuses: { name: string, value: number }[]
  years: number[]
  ranges: string[]
  selectedLocation?: AutoFilterCompany
  selectedCompany?: AutoFilterCompany
  selectedPool?: Pool
  pools: Pool[]
  donor?: Donor
  donorId?: string
  idType?: GetRegulatoryModeDonor
  selectedStatus: number
  selectedMode?: string
  selectedYear?: number
  selectedRange: string
  regulatoryModeLoading: boolean
  yearsLoading: boolean
  includeAlcohol: boolean
  rangeChecked: boolean
  yearChecked: boolean
  donorChecked: boolean
  donorLoading: boolean
  poolChecked: boolean
  allPoolsChecked: boolean
  poolLoading: boolean
  companyChecked: boolean
  allCompaniesChecked: boolean
  accountType: AccountType
  loading: boolean
  saving: boolean
  selectedCompanies: AutoFilterCompany[]
  companies: AutoFilterCompany[]
  companiesLoading: boolean
}


class WorkforceReportParameters extends React.PureComponent<WorkforceReportParametersProps & RouteComponentProps, WorkforceReportParametersState> {
  statuses = [{ name: "All", value: 1 }, { name: "Active", value: 2 }, { name: "Inactive", value: 3 }]
  ranges = ["Collected", "Reviewed", "Ordered", "Scheduled"]

  state: WorkforceReportParametersState = {
    report: getWorkforceReport(this.props.location.pathname as Report),
    statuses: this.statuses,
    years: [],
    pools: [],
    ranges: this.ranges,
    regulatoryModes: [],
    selectedStatus: this.statuses[0].value,
    selectedRange: this.ranges[0],
    regulatoryModeLoading: false,
    yearsLoading: false,
    includeAlcohol: false,
    rangeChecked: false,
    yearChecked: true,
    companyChecked: false,
    allCompaniesChecked: false,
    donorChecked: false,
    donorLoading: false,
    poolLoading: false,
    poolChecked: false,
    allPoolsChecked: false,
    accountType: AccountType.Company,
    loading: false,
    saving: false,
    selectedCompanies: [],
    companies: [],
    companiesLoading: false
  }

  typeaheadPool = React.createRef<AsyncTypeahead<Pool>>()
  subscriptions = new Subscription()
  donorSubscription?: Subscription
  printSubscription?: Subscription

  handleCompanyChange = (selected: AutoFilterCompany[]) => this.setState({ selectedCompany: selected[0] })
  handleLocationChange = (locations: AutoFilterCompany[]) => this.setState({ selectedLocation: locations[0] })
  handlePoolChange = (selected: Pool) => this.setState({ selectedPool: selected })
  handleDonorStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => this.setState({ selectedStatus: parseInt(event.target.value) })
  handleRegModeChange = (event: React.ChangeEvent<HTMLSelectElement>) => this.setState({ selectedMode: event.target.value })
  handleYearChange = (event: React.ChangeEvent<HTMLSelectElement>) => this.setState({ selectedYear: parseInt(event.target.value) })
  handleDateRangeChange = (event: React.ChangeEvent<HTMLSelectElement>) => this.setState({ selectedRange: event.target.value })
  handleDonorChecked = (e: React.ChangeEvent<HTMLInputElement>) => this.switchRadioButton(false, e.target.checked, false, false, false)
  handlePoolChecked = (e: React.ChangeEvent<HTMLInputElement>) => this.switchRadioButton(false, false, e.target.checked, false, false)
  handleCompanyChecked = (e: React.ChangeEvent<HTMLInputElement>) => this.switchRadioButton(e.target.checked, false, false, false, false)
  handleAllPoolsChecked = (e: React.ChangeEvent<HTMLInputElement>) => this.switchRadioButton(false, false, false, false, e.target.checked)
  handleAllCompaniesChecked = (e: React.ChangeEvent<HTMLInputElement>) => this.switchRadioButton(false, false, false, e.target.checked, false)

  switchRadioButton = (companyChecked: boolean, donorChecked: boolean, poolChecked: boolean, allCompaniesChecked:boolean, allPoolsChecked:boolean) => {
    const currentCompany = !!this.props.isCompanyAdmin || !!this.props.isLocationAdmin ? this.state.selectedCompany : undefined
    const currentLocation = !!this.props.isLocationAdmin ? this.state.selectedLocation : undefined
    this.setState({ poolChecked: poolChecked, companyChecked: companyChecked, donorChecked: donorChecked, 
      selectedPool: undefined, selectedCompany: currentCompany, selectedLocation: currentLocation, 
      donorId: undefined, donor: undefined, allCompaniesChecked:allCompaniesChecked, allPoolsChecked:allPoolsChecked })
  }

  handleDonorIdChange = (value: string) => this.setState({ donorId: value })

  onDonorSearch = () => {
    this.donorSubscription && this.donorSubscription.unsubscribe()
    this.donorSubscription = SearchDonorGetObservable({
      CompanyID: this.props.company || 0,
      Identifier: this.state.donorId,
      IdentifierType: this.state.idType?.Rank,
      RegulatoryModeID: 0,
      isPortalAdmin: this.props.isPortalAdmin
    }).subscribe(
    (result: Donor[]) => {
      this.setState({ donorLoading: false, donor: result[0] })
      !result.length && toast.error("Donor was not found.")
    },
    (error) => {
      this.setState({ donorLoading: false })
      toast.error(FormatError(error))
    })
  }

  handleAccountTypeChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    let at = e.target.value === AccountType.Company.toString() ? AccountType.Company : AccountType.MasterAccount
    this.setState({ accountType: at, selectedCompany: undefined })
  }

  handleYearChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ yearChecked: e.target.checked, rangeChecked: false })
  }

  handleRangeChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ yearChecked: false, rangeChecked: e.target.checked })
  }

  handleCancelClick = () => (this.props as RouteComponentProps).history?.push(Home)

  handleClearClick = () => {
    const report = getWorkforceReport(this.props.location.pathname as Report)
    this.setState({
      report: report,
      selectedCompany: (this.props.isPortalAdmin ? undefined : this.state.selectedCompany),
      accountType: AccountType.Company,
      selectedMode: this.state.regulatoryModes[0],
      selectedStatus: this.state.statuses[0].value,
      from: undefined,
      to: undefined,
      selectedYear: this.currentYear(),
      selectedRange: this.state.ranges[0],
      rangeChecked: false,
      donorChecked: false,
      poolChecked: false,
      allPoolsChecked:false,
      companyChecked: false,
      allCompaniesChecked:false,
      yearChecked: true,
      includeAlcohol: false
    })
  }

  handleGenerateReportClick = () => {
    const { report } = this.state
    switch (report.type) {
      case WorkforceReportType.CertificationRenewal:
      case WorkforceReportType.CertificationStatus:
        this.generateDriverCertification(report.type)
        break
      case WorkforceReportType.ManagementSummary:
        this.generateManagementSummary()
        break
      case WorkforceReportType.MIS:
        this.generateMIS()
        break
      case WorkforceReportType.SelectedNotTested:
        this.generateSNTPDF()
        break
      default:
        break
    }
  }

  generateDriverCertification = (reportID: number) => {
    this.setState({ saving: true })

    const { selectedCompany, selectedStatus } = this.state

    DriverCertificationReportGet(reportID, selectedCompany?.AccountID || 0, selectedStatus).subscribe(
      (base64pdf: string) => {
        this.setState({ saving: false })
        printPdf(base64pdf)
      },
      error => {
        this.setState({ saving: false })
        toast.error(FormatError(error))
      }
    )
  }

  generateCertificationStatus = () => {
    this.setState({ saving: true })
  }

  generateManagementSummary = () => {
    this.setState({ saving: true })
    const { report, from, to, selectedRange, includeAlcohol, companies, selectedCompanies } = this.state

    let companyIds: number[] = selectedCompanies?.map(a => a.AccountID) || []
    if (this.isAccountType(AccountType.MasterAccount)) {
      companyIds =  companies?.map(a => a.AccountID) || []
    } 
    
    const params: ManagementSummaryReport = {
      AccountTypeID: AccountTypeID,
      BreakByCompanies: true,
      BreakByLocations: false,
      ClientDetails: {},
      Company: companyIds,
      DateFrom: FormatDate(from),
      DateTo: FormatDate(to),
      DateType: selectedRange,
      IncludeAlcoholTests: includeAlcohol,
      MasterAccount: null,
      ReportID: report.type
    }

    this.subscriptions.add(
      ManagementSummaryReportGenerate(params).subscribe(
        (base64pdf: string) => {
          this.setState({ saving: false })
          printPdf(base64pdf)
        },
        (error) => {
          this.setState({ saving: false })
          toast.error(FormatError(error))
        }
      )
    )
  }

  generateMIS = () => {
    this.setState({ saving: true })
    const { from, to, selectedYear, yearChecked, selectedMode, companies, selectedCompanies } = this.state
    let companyIds: number[] = selectedCompanies?.map(a => a.AccountID) || []
    if (this.isAccountType(AccountType.MasterAccount)) {
      companyIds =  companies?.map(a => a.AccountID) || []
    } 
    const params: MISReport = {
      AccountType: AccountType.Company,
      AccountID: companyIds[0] || 0,
      DtFromDate: FormatDate(from),
      DtToDate: FormatDate(to),
      RegMode: selectedMode || "",
      ReportMode: yearChecked ? 1 : 2,
      Year: yearChecked ? selectedYear?.toString() || "" : "",
      Company: companyIds
    }

    this.subscriptions.add(
      MISReportGenerate(params).subscribe(
        (base64pdf: string) => {
          this.setState({ saving: false })
          printPdf(base64pdf)
        },
        (error) => {
          this.setState({ saving: false })
          toast.error(FormatError(error))
        }
      )
    )
  }
  generateSNTPDF = () => {
    this.generateSNT("pdf")
  }
  generateSNTCSV = () => {
    this.generateSNT("csv")
  }

  generateSNT = (outputFormat: string) => {
    this.setState({ loading: true })
    this.printSubscription && this.printSubscription.unsubscribe()
    const {companyChecked, poolChecked, donorChecked, allCompaniesChecked, allPoolsChecked, selectedCompany, selectedLocation, selectedPool, from, to, donor} = this.state
    const accountID = selectedLocation?.AccountID || selectedCompany?.AccountID
    this.printSubscription = SelectedNotTestedReportGenerate({
      fromDate: FormatDate(from),
      toDate: FormatDate(to),
      accountID: companyChecked ? accountID : undefined,
      poolID: poolChecked ? selectedPool?.PoolID : undefined,
      personID: donorChecked ? donor?.PersonID : undefined,
      CompanyName: selectedCompany?.Name || "",
      LocationName: selectedLocation?.Name || "",
      PoolName: selectedPool?.PoolName || "",
      DonorName: (donorChecked ? `${donor?.FirstName} ${donor?.LastName}` : ""),
      OutputFormat:outputFormat
    }).subscribe(
      data => {
        this.setState({ loading: false })
        if(outputFormat === "csv"){
          exportCsv(data, FormatTimestampFileName("SelectedNotTestedReport", "csv", new Date()))
        }
        else
        {
          printPdf(data)
        }
      },
      error => {
        this.setState({ loading: false })
        toast.error(FormatError(error))
      }
    )
  }

  validateDonorFormat = () => {
    const donorId = this.state.donorId || ""
    return !this.state.donorChecked || (donorId.length > 0 && donorId.length <= MaxDonorIdLength && DonorIdRegexp.test(donorId))
  }

  isAccountType = (type: AccountType) => this.state.accountType === type

  isReportParametersValid = () => {
    const { report, selectedCompany, selectedStatus, selectedRange, from, to, selectedMode, selectedYear, 
      companyChecked, poolChecked, allCompaniesChecked, allPoolsChecked, donorChecked, yearChecked, rangeChecked, 
      selectedPool, donor, companies, selectedCompanies } = this.state
    let companyIds: number[] = selectedCompanies?.map(a => a.AccountID) || []
    if (this.isAccountType(AccountType.MasterAccount)) {
      companyIds =  companies?.map(a => a.AccountID) || []
    }
    let companiesSelected: boolean = companyIds.length > 0
    switch (report.type) {
      case WorkforceReportType.CertificationRenewal:
      case WorkforceReportType.CertificationStatus:
        return !!selectedCompany && !!selectedStatus
      case WorkforceReportType.ManagementSummary:
        return companiesSelected && !!selectedRange && !!from && !!to
      case WorkforceReportType.MIS:
        return (companiesSelected || this.isAccountType(AccountType.MasterAccount)) && !!selectedMode && ((!!from && !!to && rangeChecked) || (yearChecked && !!selectedYear))
      case WorkforceReportType.SelectedNotTested:
        return !!from && !!to && ((companyChecked && !!selectedCompany) || allCompaniesChecked || (poolChecked && !!selectedPool) || allPoolsChecked || (donorChecked && !!donor))
      default:
        return false
    }
  }

  showDonorStatusSection = () => {
    const { report } = this.state
    return [WorkforceReportType.CertificationRenewal, WorkforceReportType.CertificationStatus].some(item => report.type === item)
  }

  showDonorSelector = () => false

  showSummarySection = () => this.state.report.type === WorkforceReportType.ManagementSummary

  showDatesSection = () => this.state.rangeChecked

  showMISSection = () => this.state.report.type === WorkforceReportType.MIS

  showSNTSection = () => this.state.report.type === WorkforceReportType.SelectedNotTested

  showAcountInput = () => {
    if (this.isAccountType(AccountType.MasterAccount)) {
      return false
    }
    const reportType = this.state.report.type
    if ((reportType === WorkforceReportType.ManagementSummary) || (reportType === WorkforceReportType.MIS) || (reportType === WorkforceReportType.SelectedNotTested)) {
      return false
    }
    return true
  }

  showCompanySelection = () => {
    if (this.isAccountType(AccountType.MasterAccount)) {
      return false
    }
    const reportType = this.state.report.type
    if ((reportType === WorkforceReportType.ManagementSummary) || (reportType === WorkforceReportType.MIS)) {
      return true
    }
    return false
  }

  currentYear = () => (new Date).getFullYear()

  needLoadCompanies = () => {
    const reportType = this.state.report.type
    const companies = this.state.companies
    if (((reportType === WorkforceReportType.ManagementSummary) || (reportType === WorkforceReportType.MIS)) && companies.length === 0) {
      return true
    }
    return false
  }

  loadCompanies = () => {
    if (this.needLoadCompanies()) {
      this.subscriptions.add(
        GetAllAccountsByNameObservable("", undefined, AccountType.Company).subscribe(
          (results) => {
            this.setState({ companies: results, companiesLoading: false })
          },
          (error) => {
            this.setState({ companiesLoading: false })
            toast.error(FormatError(error))
          }
        )
      )
    }
  }

  componentDidMount() {
    if (this.needLoadCompanies()) {
      this.setState({ regulatoryModeLoading: true, yearsLoading: true, companiesLoading: true })
    }
    else {
      this.setState({ regulatoryModeLoading: true, yearsLoading: true, companiesLoading: false })
    }

    this.loadCompanies()

    this.subscriptions.add(
      YearListGet().subscribe(
        (results) => this.setState({ years: results, yearsLoading: false, selectedYear: this.currentYear() }),
        (error) => {
          this.setState({ yearsLoading: false })
          toast.error(FormatError(error))
        }
      )
    )

    this.subscriptions.add(
      RegulatoryModesGet().subscribe(
        (results) => this.setState({ regulatoryModes: results, selectedMode: results[0], regulatoryModeLoading: false }),
        (error) => {
          this.setState({ regulatoryModeLoading: false })
          toast.error(FormatError(error))
        }
      )
    )

    this.subscriptions.add(
      RegulatoryModeObservable(0).subscribe(
        results => this.setState({ idType: results.find(item => item.PrimaryIDType === "EmployerID"), regulatoryModeLoading: false }),
        error => {
          this.setState({ regulatoryModeLoading: false })
          toast.error(FormatError(error))
        }
      )
    )

    this.subscriptions.add(
      PoolsGetObservable().subscribe(
        (results: Pool[]) => this.setState({ pools: results, poolLoading: false }),
        (error) => {
          this.setState({ poolLoading: false })
          toast.error(FormatError(error))
        }
      )
    )
  }

  componentWillUnmount() {
    this.subscriptions && this.subscriptions.unsubscribe()
    this.donorSubscription && this.donorSubscription.unsubscribe()
    this.printSubscription && this.printSubscription.unsubscribe()
  }

  componentDidUpdate(prevProps: WorkforceReportParametersProps & RouteComponentProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.handleClearClick()
    }
    this.loadCompanies()
  }
  onCompanyChange = (selected: AutoFilterCompany[]) => {
    this.setState({ selectedCompanies: selected || [] })
  }
  render() {
    const { report, selectedStatus, includeAlcohol, selectedMode, selectedCompany, from, to, yearChecked, rangeChecked, 
      donorChecked, donorLoading, donor, poolChecked, companyChecked, donorId, selectedYear, selectedRange, regulatoryModeLoading, 
      yearsLoading, allCompaniesChecked, allPoolsChecked } = this.state
    const showCompanyLabel = ((!this.showMISSection() && !this.showSummarySection()) || !!this.props.isCompanyAdmin) && !this.showSNTSection()
    const showFilterByCompany = ((this.showMISSection() || this.showSummarySection()) && (this.props.isPortalAdmin || this.props.isSiteAdmin)) && !this.showSNTSection()
    const showFilterByMasterAccount = ((this.showMISSection() || this.showSummarySection()) && (this.props.isPortalAdmin || this.props.isSiteAdmin)) && !this.showSNTSection()
    //const generateReportText = this.showSNTSection() ? "Export PDF" : "Continue"
    const isSNT = this.showSNTSection()
    const showAllCompanies = isSNT && this.props.isPortalAdmin
    const showAllPools = isSNT && this.props.isPortalAdmin
    return (<AppPageWrapper parentClassName={"align-items-center"} showNav>
      <Modal.Dialog size="lg">
        <Modal.Header>
          <Modal.Title className="text-uppercase">{report.title}</Modal.Title>
        </Modal.Header>
        <ModalBody>
          <Form>
            <Form.Row className="form-group">
              {showCompanyLabel && <Form.Label column className="m-1" lg={3}>Company</Form.Label>}
              {showFilterByCompany &&
                <Col lg={3}>
                  <Form.Check
                    id="filter-by-company"
                    name="filter-by-account"
                    type="radio"
                    label="Company"
                    className="abc-radio mt-2"
                    inline
                    value={AccountType.Company}
                    checked={this.isAccountType(AccountType.Company)}
                    onChange={this.handleAccountTypeChanged}
                  />
                </Col>}
              {this.showAcountInput() && <Col lg={8}>
                <AccountInput
                  accountType={this.state.accountType}
                  filter
                  disabled={!!this.props.isCompanyAdmin || this.isAccountType(AccountType.MasterAccount)}
                  onChange={this.handleCompanyChange} />
              </Col>}
            </Form.Row>
            <Form.Row>
              {this.showCompanySelection() && <Col lg={11}>
                <DualListBox
                  disabled={false}
                  options={this.state.companies || []}
                  selected={this.state.selectedCompanies || []}
                  idKey="AccountID"
                  labelKey="Name"
                  availableTitle="Available"
                  selectedTitle="Selected"
                  onChange={this.onCompanyChange}                //isConsortium={true}
                />
              </Col>}
            </Form.Row>
            {showFilterByMasterAccount &&
              <Form.Row className="form-group">
                <Col lg={3}>
                  <Form.Check id="filter-by-masteraccount"
                    name="filter-by-account"
                    type="radio"
                    label="Master Portal"
                    className="abc-radio mt-2"
                    inline
                    value={AccountType.MasterAccount}
                    checked={this.isAccountType(AccountType.MasterAccount)}
                    onChange={this.handleAccountTypeChanged}
                  />
                </Col>
              </Form.Row>}

            {this.showSNTSection() && <>
            <Form.Row className="form-group">
              <Col lg={3}>Date Collected</Col>
              <Col lg={8}>
                <FromToDates from={from} to={to} onChangeFrom={(date: Date) => {this.setState({from: date})}} onChangeTo={(date: Date) => {this.setState({to: date})}}/>
              </Col>
            </Form.Row>
            <Form.Row className="form-group"><Col lg={3}>Filter By:</Col></Form.Row>
            <Form.Row className="form-group">
              <Col lg={3}>
                  <Form.Check
                    id="filter-by-company"
                    name="filter-by"
                    type="radio"
                    label="Company"
                    className="abc-radio mt-2"
                    inline
                    checked={companyChecked}
                    onChange={(e) => this.handleCompanyChecked(e)}
                    />
                </Col>
                <Col lg={8}>
                  {companyChecked && <CompanyInput disabled={!companyChecked} onChange={this.handleCompanyChange} />}
                </Col>
            </Form.Row>
            {companyChecked && !!selectedCompany && <Form.Row className="form-group">
              <Col lg={{span: 8, offset: !!this.props.isLocationAdmin ? 0 : 3}}>
                  <LocationInput
                    hideInactive
                    filter
                    companyID={selectedCompany?.AccountID || 0}
                    disabled={!!this.props.isLocationAdmin}
                    onChange={this.handleLocationChange} />
              </Col>
              </Form.Row>}
              {showAllCompanies && <Form.Row className="form-group">
              <Col lg={3}>
                  <Form.Check
                    id="filter-by-all-companies"
                    name="filter-by"
                    type="radio"
                    label="ALL Companies"
                    className="abc-radio mt-2"
                    inline
                    checked={allCompaniesChecked}
                    onChange={(e) => this.handleAllCompaniesChecked(e)}
                    />
                </Col>
                <Col lg={8}>
                  &nbsp;
                </Col>
              </Form.Row>}

              {this.showDonorSelector() && <Form.Row className="form-group">
                <Col lg={3}>
                  <Form.Check id="filter-by-donor" name="filter-by"
                    type="radio"
                    label="Donor ID"
                    className="abc-radio mt-2"
                    inline
                    checked={donorChecked} onChange={(e) => this.handleDonorChecked(e)}
                  />
                </Col>
                <Col lg={8}>
                  {donorChecked && <InputGroup className="mb-3">
                    <TextFormControl value={donorId}
                      disabled={!donorChecked}
                      maxLength={MaxDonorIdLength}
                      changeHandler={(value) => this.handleDonorIdChange(value)}
                      isValid={() => this.validateDonorFormat()}
                      enterTapHandler={this.onDonorSearch} />
                    <Form.Control.Feedback className="order-last" type="invalid">{InvalidDonorId}</Form.Control.Feedback>
                    <InputGroup.Append>
                      <Button className="btn-rounded-right" onClick={() => this.onDonorSearch()} disabled={!donorId}>
                        {this.state.donorLoading ? <Spinner size="sm" animation="border" /> : <FaSearch />}
                      </Button>
                    </InputGroup.Append>
                  </InputGroup>}
                  {!donorLoading && donor && <Form.Text muted>Donor: {donor.FirstName} {donor.LastName} was found.</Form.Text>}
                </Col>
              </Form.Row>}
              <Form.Row className="form-group">
                <Col lg={3}>
                  <Form.Check id="filter-by-pool" name="filter-by"
                    type="radio"
                    label="Pool Name"
                    className="abc-radio mt-2"
                    inline
                    checked={poolChecked} onChange={(e) => this.handlePoolChecked(e)}
                  />
                </Col>
                <Col lg={8}>
                  {poolChecked && <AsyncTypeahead id="pool-select"
                  emptyLabel="No Pools Found"
                  ref={this.typeaheadPool}
                  filterBy={(option, props) => props.selected.length > 0 || option.PoolName.toLowerCase().indexOf(props.text.toLowerCase()) !== -1 || option.Code.toLowerCase().indexOf(props.text.toLowerCase()) !== -1}
                  isLoading={this.state.poolLoading}
                  onChange={items => this.handlePoolChange(items[0])}
                  onSearch={() => { }}
                  options={this.state.pools}
                  selected={this.state.selectedPool ? [this.state.selectedPool] : []}
                  minLength={0}
                  labelKey={(option) => `${option.PoolName} (${option.Code})${ option.IsConsortium ? " - Consortium Pool" : ""}`}
                  disabled={!poolChecked}
                  placeholder="Enter the Pool name or Code"
                  inputProps={{ autoComplete: "chrome-off" }}>
                  {!this.state.poolLoading && poolChecked &&
                    <Button variant="toggle" onClick={() => this.typeaheadPool.current?.toggleMenu()}>
                      <FaAngleDown />
                    </Button>}
                </AsyncTypeahead>}
                </Col>
              </Form.Row>
              {showAllPools && <Form.Row className="form-group">
                <Col lg={3}>
                  <Form.Check id="filter-by-all-pools" name="filter-by"
                    type="radio"
                    label="ALL Pools"
                    className="abc-radio mt-2"
                    inline
                    checked={allPoolsChecked} onChange={(e) => this.handleAllPoolsChecked(e)}
                  />
                </Col>
                <Col lg={8}>
                  &nbsp;
                </Col>
              </Form.Row>}
            </>}

            {this.showDonorStatusSection() && <Form.Row className="form-group">
              <Form.Label className="m-1" column lg={3}>Donor Status</Form.Label>
              <Col lg={8}>
                <Form.Control id="donor" as="select" onChange={this.handleDonorStatusChange} value={selectedStatus || ""}>
                  {this.state.statuses?.map(s => <option value={s.value} key={s.name} selected={s.value === selectedStatus}>{s.name}</option>)}
                </Form.Control>
              </Col>
            </Form.Row>}
            {this.showSummarySection() && <Form.Row className="form-group">
              <Form.Label column className="m-1" lg={3}>Include Alcohol Tests</Form.Label>
              <ToggleSwitch className="m-2" on="Yes" off="No" checked={includeAlcohol} onCheck={checked => this.setState({ includeAlcohol: checked })} />
            </Form.Row>}
            {this.showMISSection() && <Form.Row className="form-group">
              <Form.Label column className="m-1" lg={3}>Regulatory Mode</Form.Label>
              <Col lg={8}>
                <Form.Control id="reg-mode" as="select" onChange={this.handleRegModeChange} value={selectedMode || ""} disabled={regulatoryModeLoading}>
                  {this.state.regulatoryModes?.map(m => <option value={m} key={m} selected={m === selectedMode}>{m}</option>)}
                </Form.Control>
              </Col>
            </Form.Row>}
            {(this.showMISSection()) && <>
              <Form.Row className="form-group">
                <Col lg={3}>
                  <Form.Check id="filter-by-year" name="filter-by"
                    type="radio"
                    label="By Calendar Year"
                    className="abc-radio mt-2"
                    inline
                    checked={yearChecked}
                    onChange={this.handleYearChecked}
                  />
                </Col>
                <Col lg={8} className="mx-2">
                  <Form.Control id="years" as="select" onChange={this.handleYearChange} value={selectedYear || ""} disabled={!yearChecked || yearsLoading}>
                    <option value={undefined} key={0} selected={selectedYear === undefined}>Select Year</option>
                    {this.state.years?.map(y => <option value={y} key={y} selected={y === selectedYear}>{y}</option>)}
                  </Form.Control>
                </Col>
              </Form.Row>
              <Form.Row className="form-group">
                <Col lg={3}>
                  <Form.Check id="filter-by-range" name="filter-by"
                    type="radio"
                    label="By Date Range"
                    className="abc-radio mt-2"
                    inline
                    checked={rangeChecked}
                    onChange={this.handleRangeChecked}
                  />
                </Col>
                <Col lg={8} className="mx-2">
                  {this.showDatesSection() && <FromToDates from={from} to={to} onChangeFrom={(date: Date) => { this.setState({ from: date }) }} onChangeTo={(date: Date) => { this.setState({ to: date }) }} />}
                </Col>
              </Form.Row>
            </>}
            {(this.showSummarySection()) && <>
              <Form.Row className="form-group">
                <Form.Label column className="m-1" lg={3}>By Date Range</Form.Label>
                <Col lg={8}>
                  <Form.Control id="date-range" as="select" onChange={this.handleDateRangeChange} value={selectedRange || ""}>
                    {this.state.ranges?.map(r => <option value={r} key={r} selected={r === selectedRange}>{r}</option>)}
                  </Form.Control>
                </Col>
              </Form.Row>
              <Form.Row>
                <Col lg={3} className="m-1"></Col>
                <Col lg={8}>
                  <FromToDates from={from} to={to} onChangeFrom={(date: Date) => { this.setState({ from: date }) }} onChangeTo={(date: Date) => { this.setState({ to: date }) }} />
                </Col>
              </Form.Row>
            </>}
          </Form>
        </ModalBody>
        <Modal.Footer className="justify-content-between">
          <Button variant="secondary" onClick={this.handleCancelClick}>Cancel</Button>
          <Button variant="secondary" onClick={this.handleClearClick}>Clear Filter</Button>
          {!isSNT && <ActionButton variant="primary" disabled={!this.isReportParametersValid()} onClick={this.handleGenerateReportClick} spin={this.state.loading || this.state.saving} disableOnSpin>Continue</ActionButton>}
          {isSNT && <ActionButton variant="secondary" disabled={!this.isReportParametersValid()} onClick={this.generateSNTPDF} spin={this.state.loading || this.state.saving} disableOnSpin>Export PDF&nbsp;<FaFilePdf /></ActionButton>}
          {isSNT && <ActionButton variant="primary" disabled={!this.isReportParametersValid()} onClick={this.generateSNTCSV} spin={this.state.loading || this.state.saving} disableOnSpin>Export CSV&nbsp;<FaFileCsv /></ActionButton>}
        </Modal.Footer>
      </Modal.Dialog>
    </AppPageWrapper>)
  }
}

function mapStateToProps(state: AppState): WorkforceReportParametersProps {
  return {
    isLocationAdmin: isLocationAdmin(state),
    isCompanyAdmin: isCompanyAdmin(state),
    isPortalAdmin: isPortalAdmin(state),
    isSiteAdmin: isSiteAdmin(state),
    company: GetSelectedAssignedClinic(state)?.AccountID
  }
}

const ConnectedWorkforceReportParameters = connect(mapStateToProps, null)(WorkforceReportParameters)
export default ConnectedWorkforceReportParameters